import { useCheckoutStateStore } from '../components/checkout/stores/checkoutStateStore';
import { useOrderTypeStore } from '../components/shoppingCart/stores/orderTypeStore';
import { OrderType } from '../components/shoppingCart/stores/orderTypeStore.model';
import { useShoppingCartStore } from '../components/shoppingCart/stores/shoppingCartStore';
import { resolveOrderTypeWarehouseCode } from './resolveOrderTypeWarehouseCode';

/**
 * Orchestrates the order-type toggle: switches the order type and triggers a
 * read-only, warehouse-aware cart re-fetch reflecting the newly selected order
 * type. Switching to "Klikk og hent" re-checks inventory against the resolved
 * click & collect store's warehouse; switching to "Online" re-checks against
 * the default online warehouse.
 */
export function useOrderTypeToggle() {
  const orderTypeStore = useOrderTypeStore();
  const checkoutStateStore = useCheckoutStateStore();
  const shoppingCartStore = useShoppingCartStore();

  async function handleOrderTypeChange(value: string): Promise<void> {
    const orderType = value as OrderType;

    // A stock-summary shown for the previous order type/warehouse is stale
    // the instant the customer switches — only `verifyStock()` (called on
    // submit) should make it visible again.
    shoppingCartStore.stockSummaryVisible = false;

    orderTypeStore.setOrderType(orderType);

    const warehouseCode = await resolveOrderTypeWarehouseCode(orderType);

    await checkoutStateStore.refetchCartForOrderType(warehouseCode);
  }

  return { handleOrderTypeChange };
}
